import {
  ROUTE_PRINCIPLE_SPIRIT,
  ROUTE_PRINCIPLE_MINDSET,
  ROUTE_PRINCIPLE_NUTRITION,
  ROUTE_PRINCIPLE_EXERCISE
} from 'routes/routes';

export default [
  {
    title: 'Spirit',
    cdnId: 'app_images/spirit-wide-arms',
    route: ROUTE_PRINCIPLE_SPIRIT
  },
  {
    title: 'Mindset',
    cdnId: 'app_images/mindset-meditate',
    route: ROUTE_PRINCIPLE_MINDSET
  },
  {
    title: 'Nutrition',
    cdnId: 'app_images/nutrition-containers',
    route: ROUTE_PRINCIPLE_NUTRITION
  },
  {
    title: 'Exercise',
    cdnId: 'app_images/exercise-db-row',
    route: ROUTE_PRINCIPLE_EXERCISE
  }
];
